import { useEffect } from "react";
import useGetDataFromSelect from "./useGetDataFromSelect";

/**
 * Hook dùng chung cho autocomplete có load-more (infinite scroll).
 * @param {string} path - API endpoint
 * @param {object} params - Query params (limit, searchField, searchValue, ...)
 * @param {boolean} enabled - Bật/tắt fetch
 * @param {string} resetKey - Thay đổi key này sẽ reset về trang 1
 */
function useInfiniteAutocomplete(path, params, enabled = true, resetKey = "") {
  const shouldFetch = Boolean(enabled && path);

  const { data, isLoading, setSize, isValidating, hasMore } = useGetDataFromSelect(shouldFetch ? path : "", params, true);

  useEffect(() => {
    if (!shouldFetch) return;
    setSize(1);
  }, [shouldFetch, path, resetKey, setSize]);

  const onLoadMore = () => {
    if (!isLoading && !isValidating && hasMore) {
      setSize((prev) => prev + 1);
    }
  };

  return {
    items: Array.isArray(data?.data) ? data.data : [],
    count: data?.count,
    isLoading,
    loadingMore: isValidating && !isLoading,
    hasMore,
    onLoadMore,
  };
}

export default useInfiniteAutocomplete;
